import Immutable from 'immutable';
import {
  FLAG_GETTING_HOLIDAYS,
  GET_HOLIDAYS,
  CLEAR_HOLIDAYS,
  FLAG_HOLIDAY_ACTIVITY,
  GET_HOLIDAY,
  CLEAR_HOLIDAY,
  FLAG_GETTING_HOLIDAY_DATES,
  GET_HOLIDAY_DATES,
  CLEAR_HOLIDAY_DATES,
} from '../../../actions/types/human-resources/Holiday';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  dates: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_HOLIDAYS:
      return state.setIn(['all', 'loading'], payload);
    case GET_HOLIDAYS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_HOLIDAYS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_HOLIDAY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_HOLIDAY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_HOLIDAY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_GETTING_HOLIDAY_DATES:
      return state.setIn(['dates', 'loading'], payload);
    case GET_HOLIDAY_DATES:
      return state.setIn(['dates', 'content'], Immutable.List(payload));
    case CLEAR_HOLIDAY_DATES:
      return state.setIn(['dates', 'content'], Immutable.List());
    default:
      return state;
  }
};
